<template>
    <div>
        <div class="employee-view-tabs mb-4">
            <ul class="nav nav-tabs nav-tabs-2" id="myTab" role="tablist">
                <li class="nav-item" v-if="transaction_fee">
                    <a
                            :class="{ 'nav-link': true, 'active': activeTab === 'company-wise' }"
                            id="reversal-transfer-tab"
                            data-toggle="tab"
                            href="#company-wise"
                            role="tab"
                            aria-controls="company-wise"
                            aria-selected="false"
                            @click="setActiveTab('company-wise')"
                    >
                        Company-Wise Transaction Fee
                    </a>
                </li>
                <li class="nav-item" v-if="transaction_fee_configuration">
                    <a
                            :class="{ 'nav-link': true, 'active': activeTab === 'source-wise' }"
                            data-toggle="tab"
                            href="#source-wise"
                            role="tab"
                            aria-controls="loan-amount-ledger-correction"
                            aria-selected="false"
                            @click="setActiveTab('source-wise')"
                    >
                        Source-Wise Transaction Fee
                    </a>
                </li>
            </ul>
        </div>
        <div class="tab-content" id="myTabContent">
            <div
                    v-if="transaction_fee"
                    :class="{ 'tab-pane': true, 'fade': true, 'show': activeTab === 'company-wise', 'active': activeTab === 'company-wise' }"
                    id="company-wise"
                    role="tabpanel"
                    aria-labelledby="company-wise"
            >
                <div class="tab-pane fade show active" id="correction-tab" role="tabpanel" aria-labelledby="company-wise">
                    <CompanytransactionFee></CompanytransactionFee>
                </div>
            </div>
            <div
                    :class="{ 'tab-pane': true, 'fade': true, 'show': activeTab === 'source-wise', 'active': activeTab === 'source-wise' }"
                    id="source-wise"
                    role="tabpanel"
                    aria-labelledby="loan-amount-ledger-correction"
            >
                <div class="tab-pane fade show active" id="correction-tab" role="tabpanel" aria-labelledby="source-wise">
                    <transactionFeeConfiguration></transactionFeeConfiguration>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                activeTab: 'company-wise',
                transaction_fee_configuration: null,
                transaction_fee: null,
                isLoading: true,
            };
        },
        methods: {
            setActiveTab(tab) {
                this.activeTab = tab;
            },
            finishProgress() {
                this.isLoading = false;
                this.$Progress.finish();
            },
        },
        created() {
            const queryTab = this.$route.query.tab;
            if (queryTab) {
                this.activeTab = queryTab;
            }
        },
        mounted() {
            this.$Progress.start();
            this.can('transaction_fee')
                .then((result) => {
                    this.transaction_fee = result.transaction_fee;
                    this.finishProgress();
                    if (!result.transaction_fee) {
                        this.setActiveTab('source-wise');
                    }
                })
                .catch(this.finishProgress);

            this.can('transaction_fee_configuration')
                .then((result) => {
                    this.transaction_fee_configuration = result.transaction_fee_configuration;
                    this.finishProgress();
                    if (!result.transaction_fee_configuration) {
                        this.setActiveTab('company-wise');
                    }
                })
                .catch(this.finishProgress);
        },
    };
</script>






